import { AuthCubit, IAuthCubit } from "../../blocs/auth/AuthBloc";
import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase";
import { hasRight, UserRight } from "../models/User";

interface NavigationEvent {
    path: string;
    authState: string,
    uid: string;
    userAgent: string;
    fromWhere?: string;
}

abstract class IAnalyticsService {
    abstract logNavigationEvent(path: string): void;
}

class AnalyticsService extends IAnalyticsService {
    private authBloc: IAuthCubit = AuthCubit.getInstance();

    private static instance: IAnalyticsService | undefined;
    public static getInstance(): IAnalyticsService {
        if (this.instance === undefined) {
            this.instance = new AnalyticsService();
        }
        return this.instance;
    }

    private constructor() {
        super();
    }

    private uuidv4(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
            .replace(/[xy]/g, function (c) {
                const r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : ((r & 0x3) | 0x8);
                return v.toString(16);
            });
    }


    private getNavigationEvent(path: string): NavigationEvent {
        let authState = this.authBloc.state;
        let uid = localStorage.getItem('uid');
        if (uid === undefined || uid === null) {
            uid = this.uuidv4();
            localStorage.setItem('uid', uid);
        }
        return {
            path,
            uid,
            authState: JSON.stringify(authState),
            userAgent: window.navigator.userAgent,
        };
    }

    logNavigationEvent(path: string): void {
        if (!process.env.NODE_ENV ||
            process.env.NODE_ENV === 'development' ||
            hasRight(UserRight.canSeeAdminPanel, this.authBloc.state.user)) {
            console.info("naviagtion", this.getNavigationEvent(path));
        } else {
            logEvent(analytics, "navigation", this.getNavigationEvent(path));
        }
    }
}

export { IAnalyticsService, AnalyticsService }